export default function (action, args, displayId, payload) {
    console.log('cart-rule-action:clear_cart_items', { action, args })

    const store = window.addiesaas.store

    Object.values(store.getters['Shop/Orders/Cart/cartItems'])
        .forEach(item => store.dispatch('Shop/Orders/Cart/removeCartItem', item))
}
